export default "__VITE_ASSET__DbfwP2Hi__"